import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { getTintControlData, setCurrentWindowTintPage } from '../../../../../action/roomControlAction';
import { setGoHome, setLoader } from '../../../../action/homeAction';
import sleepin_icon from "../assets/tint/ico_clock.svg";
import zones_icon from "../assets/tint/ico_window.svg";
import WindowSleepin from './WindowSleepin';
import WindowZones from './WindowZones';
import ActiveOverride from "./ActiveOverride"
import { CMSPath } from '../../../../../config/constant';

function Index(props) {
	const [currentPage, setCurrentPage] =  useState("")
	console.log("View rendered");
	console.log(props.tintControlData)

	useEffect(() => {
		if(!props.guestIsLoggedIn) return
		props.setLoader(true, "Fetching data...")
		props.getTintControlData(props.guestDetail, (status) => {
			props.setLoader(false, "")
			if(status){

			}
		})
		return () => {
			props.setCurrentWindowTintPage("")
		}
	},[])
  return (
    <div class="main-container">
		{ !props.currentTintWindow &&
			<>
				<header class="inner-pages subpages">
					<a onClick={() => props.setGoHome(true)} class="button-back"></a>
					<div class="heading align-center">
						<div class="splash-brand">
							<img src={`${CMSPath}${props.logo}`} />
						</div>
						{/* <p class="bold">Tint Controls</p> */}
					</div>
				</header>
				<section id="customizeRoom" class="widgets padding-bottom-2 margin-0">

					<div class="widget-header widget-header-checkin">
						{ props.currentWidget.widgetHeaderImageUrl && 
							<div class="widget-header-img">
								<img src={`${CMSPath}${props.currentWidget.widgetHeaderImageUrl}`} alt={props.currentWidget.displayName} />
							</div>
						}
						<div class="widget-header-title">{props.currentWidget.displayName}</div>
					</div>

					<div class="widgets">
						<div class="row">
							<div class="col">
								<p class="heading">View Smart Windows</p>
							</div>
						</div>
						<div class="row">
							<div class="col col-2 menu-items">
								<a onClick={() => props.setCurrentWindowTintPage("Override")} class="tile-sm thumbnails tile-container">
									<div class="thumb-img">
										<img src={zones_icon}/>
									</div>
									<div class="thumb-text align-center">
										<p class="thumb-heading">Override</p>
									</div>
								</a>
								<a onClick={() => props.setCurrentWindowTintPage("SleepIn")} class="tile-sm thumbnails tile-container">
									<div class="thumb-img">
										<img src={sleepin_icon}/>
									</div>
									<div class="thumb-text align-center">
										<p class="thumb-heading">Sleep-in</p>
									</div>
								</a>
							</div>
						</div>
					</div>
				</section>

				<ActiveOverride response={props.tintControlData} />
			</>
		}
		{ props.currentTintWindow == "Override" &&  <WindowZones goBack={() => props.setCurrentWindowTintPage("")} />}
		{ props.currentTintWindow == "SleepIn" && <WindowSleepin goBack={() => props.setCurrentWindowTintPage("")} />}		
        </div>
  )
}

const mapStateToProps = state => {
	return {
        guestDetail: state.store.home.guestDetails,
		guestIsLoggedIn: state.store2.guestIsLoggedIn,
		currentTintWindow: state.store.currentTintWindow,
		tintControlData: state.store.TintControlData,
		logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
		currentWidget: state.store.sideNavBar.currentWidget,
	}
}
export default connect(mapStateToProps,
	{
		setCurrentWindowTintPage,
		setGoHome,
		getTintControlData,
		setLoader
	})(Index);